
import { DetectedLocation } from '../mappings/LocationMapping';

export const applyLocationFilter = (dbQuery: any, detectedLocation: DetectedLocation) => {
  const { type, info } = detectedLocation;
  
  if (type === 'city') {
    return dbQuery
      .eq('country', info.country)
      .ilike('city', `%${info.city}%`);
  } else if (type === 'region') {
    return dbQuery
      .eq('country', info.country)
      .ilike('region', `%${info.region}%`);
  } else if (type === 'country') {
    return dbQuery.eq('country', info.country);
  }
  
  return dbQuery;
};
